export const createFetchAppContextAction = () => {
    return {
        type: '@APP_CONTEXT/FETCH_APP_CONTEXT',
    } as const;
};

export const createFetchAppContextSuccessAction = (environment?: string | null, loggedUserId?: string | null) => {
    return {
        type: '@APP_CONTEXT/FETCH_APP_CONTEXT_SUCCESS',
        payload: {
            environment,
            loggedUserId,
        },
    } as const;
};

export const createFetchAppContextFailureAction = () => {
    return {
        type: '@APP_CONTEXT/FETCH_APP_CONTEXT_FAILURE',
    } as const;
};

export const createSignOutAction = () => {
    return {
        type: '@APP_CONTEXT/SIGN_OUT',
    } as const;
};

export const createSetClientAction = (clientName: string, siren: string, isInternal: boolean) => {
    return {
        type: '@APP_CONTEXT/SET_CLIENT',
        payload: {
            clientName,
            siren,
            isInternal,
        },
    } as const;
};

export type AppContextAction =
    | ReturnType<typeof createFetchAppContextAction>
    | ReturnType<typeof createFetchAppContextSuccessAction>
    | ReturnType<typeof createFetchAppContextFailureAction>
    | ReturnType<typeof createSignOutAction>
    | ReturnType<typeof createSetClientAction>;
